import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpiredSessionComponent } from './expired-session/expired-session.component';
import { ButtonModule } from '@nx-fe/button';
import { PipesModule } from '@nx-fe/pipes';

@NgModule({
  imports: [CommonModule, ButtonModule, PipesModule],
  declarations: [ExpiredSessionComponent],
  exports: [ExpiredSessionComponent],
  providers: [{ provide: 'Window', useValue: window }],
})
export class ExpiredSessionModule {}
